import NotificationsIcon from "@mui/icons-material/Notifications";
import Badge from "@mui/material/Badge";
import { GetNotificationList } from "../store/NotificationAtom";
import { useEffect, Fragment, useState } from "react";
import { settingsService } from "../services/settingsService";
import { SetNotificationList } from "../store/NotificationAtom";
import { useLocation, useNavigate } from "react-router-dom";
import { Combobox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";

const NotificationPane = () => {
  const getNotification = GetNotificationList();
  const setNotifications = SetNotificationList();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  const openNotification = () => {
    navigate(`/Users/notifications` + "?new_list=true");
  };


  return (
    <>
      <div class="dropdown">
        <button
          className="p-1.5 outline-none focus:outline-none hover:bg-gray-200 active:bg-gray-100 rounded-full"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <Badge  
            onClick={() => openNotification()}
            badgeContent={3}
            color="primary"
          >
            <NotificationsIcon className="" color="action" />
          </Badge>
        </button>
     
      </div>
    </>
  );
};

export default NotificationPane;
